import { BoxProps } from '@chakra-ui/react';
import { BaseChartImage } from './BaseChartImage';

export const MinimizeLossesChart = (props: BoxProps) => (
    <BaseChartImage {...props}>
        <svg width="231" height="22" viewBox="0 0 231 22" fill="none">
            <path
                d="M2 21L10.428 17.5H13.5331H17.5253L19.2996 14.5L23.2918 18.5L27.284 17.5L29.5019 14.5L35.7121 12.5L39.7043 15.5L46.358 17.5L49.9066 14.5H57.0039L62.3268 12.5H67.6498L72.0856 14.5L81.8444 10.5L87.6109 12.5L93.3774 10.5L101.805 12.5L106.241 9H113.339H118.661L123.984 10.5L133.743 9L139.953 7.5L148.825 5.5H154.148L158.584 7.5H163.019L167.012 10.5H172.778L179.875 7.5L189.634 5.5L194.514 7.5L200.28 4L203.385 5.5H206.934L210.482 4L214.475 5.5L220.685 2.5L222.459 4L230 1"
                stroke="#4CAFE3"
                strokeWidth="1.5"
            />
        </svg>
    </BaseChartImage>
);
